import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { downloadStationsPriceReport } from '../operations/downloadStationsPriceReport';

import { STATUS_LOADING } from 'common/constants';

export const setStationsPriceReportDownloadStatus = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(downloadStationsPriceReport.pending, (state) => {
    state.stationsPriceReport.downloadStatus = STATUS_LOADING.load;
  })
  .addCase(downloadStationsPriceReport.fulfilled, (state) => {
    state.stationsPriceReport.downloadStatus = STATUS_LOADING.done;
  })
  .addCase(downloadStationsPriceReport.rejected, (state) => {
    state.stationsPriceReport.downloadStatus = STATUS_LOADING.error;
  });
